import { apiClient } from '../api'
import { ReportFilters } from '../../components/shared/filters/types'
import type { ReferenceLinkInput } from '../../components/shared/referenceLinks/types'
import { downloadBlob } from '../../utils/download'

export interface ExceptionType {
  id: number
  code: string
  data_domain: string
  exception_type: string
  business_area: string
  name_short?: string
  name: string
  overview?: string
  why_flagged?: string
  search_keywords?: string[]
  links: ReferenceLinkInput[]
  is_active: boolean
  markets?: string[]
  visible_to_roles?: string[]
  sample_type?: string
  sample_value?: number
  measure_type?: string
  good_threshold?: number
  watch_threshold?: number
  poor_threshold?: number
  weight?: number
  function_name?: string
  report_component?: string
  created_at: string
  updated_at: string
}

export interface ExceptionTypesResponse {
  exception_types: ExceptionType[]
  total: number
  page: number
  per_page: number
  pages: number
  search_aliases?: Record<string, string[]>
}

export interface ListExceptionTypesParams {
  page?: number
  per_page?: number
  search?: string
  data_domain?: string
  exception_type?: string
  business_area?: string
  is_active?: string
  market?: string
  visible_to_role?: string
}

export const mapFiltersToParams = (
  filters: ReportFilters,
  isActive: string,
  page: number,
  perPage: number,
): ListExceptionTypesParams => {
  const params: ListExceptionTypesParams = { page, per_page: perPage }
  if (filters.textSearch) params.search = filters.textSearch
  if (filters.dataDomain) params.data_domain = filters.dataDomain
  if (filters.exceptionType) params.exception_type = filters.exceptionType
  if (filters.businessArea) params.business_area = filters.businessArea
  if (filters.market) params.market = filters.market
  if (filters.visibleToRole) params.visible_to_role = filters.visibleToRole
  if (isActive !== '') params.is_active = isActive
  return params
}

export const exceptionTypesApi = {
  async list(params: ListExceptionTypesParams): Promise<ExceptionTypesResponse> {
    const search = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.append(key, String(value))
      }
    })
    const response = await apiClient.get(`/admin/exception-types?${search.toString()}`)
    return response.data
  },

  // Export every matching exception type (content + flattened links) to Excel.
  // Honors the current filters; pagination params are intentionally dropped.
  async export(filters: ReportFilters, isActive: string): Promise<void> {
    const params = mapFiltersToParams(filters, isActive, 1, 0)
    delete params.page
    delete params.per_page
    const search = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.append(key, String(value))
      }
    })
    const qs = search.toString()
    await downloadBlob(
      `/admin/exception-types/export${qs ? `?${qs}` : ''}`,
      'exception_types',
    )
  },
}
